var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 24,
    viewBox: "0 0 22.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#050606;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.5,18h-.15A7.508,7.508,0,0,0,5.2,13.03a7.5,7.5,0,0,0-3.44,4.48,7.3,7.3,0,0,0-.27,2H0A8.78,8.78,0,0,1,.42,16.8a9.06,9.06,0,0,1,1.17-2.4,9.22,9.22,0,0,1,1.84-2,8.45,8.45,0,0,1,2.38-1.34A6.43,6.43,0,0,1,3.74,8.91,5.88,5.88,0,0,1,3,6,5.985,5.985,0,0,1,6.66.47a6.06,6.06,0,0,1,4.68,0A5.985,5.985,0,0,1,15,6a5.84,5.84,0,0,1-.19,1.51,6.3,6.3,0,0,1-.56,1.4,6.382,6.382,0,0,1-2.06,2.21,9,9,0,0,1,4.31,3.44ZM4.5,6a4.45,4.45,0,0,0,.35,1.75,4.5,4.5,0,0,0,5.9,2.4,4.59,4.59,0,0,0,2.4-2.4,4.55,4.55,0,0,0,0-3.5,4.5,4.5,0,0,0-5.9-2.4,4.59,4.59,0,0,0-2.4,2.4A4.48,4.48,0,0,0,4.5,6Zm15,13.5h3V21h-3v3H18V21H15V19.5h3v-3h1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterEntity);
export default __webpack_public_path__ + "static/media/RegisterEntity.9a2a5fff.svg";
export { ForwardRef as ReactComponent };